const HTTP_METHODS = ["connect", "delete", "get", "head", "options", "patch", "post", "put", "trace"];
const httpMethods = new Set(HTTP_METHODS);
export {
  HTTP_METHODS,
  httpMethods
};
//# sourceMappingURL=http-methods.js.map
